export const CREATE_BLOCK_LENDING = `
  mutation ($rentalItemId: Int!, $note: String, $fromDate: DateString!, $toDate: DateString!, $quantity: Int!) {
    blockRentalItemReservation(rentalItemId: $rentalItemId, note: $note, fromDate: $fromDate, toDate: $toDate, quantity: $quantity) {
      id
    }
  }
`
